module.exports = __webpack_public_path__ + "static/media/pintrest.0af26790.svg";